export default __webpack_public_path__ + "static/media/twitter.f87991dc.svg";